<template>
  <div class="import-dowload-record-table">
    <a-form layout="inline">
      <a-form-item>
        <a-range-picker v-model="params.taskDate" format="YYYY-MM-DD" @change="queryList()">
          <a-icon slot="suffixIcon" type="calendar" />
        </a-range-picker>
      </a-form-item>
      <a-form-item>
        <a-input-search v-model="params.fileName" placeholder="文件名" @search="queryList()"/>
      </a-form-item>
      <a-form-item>
        <a-button @click="onReset()">重置</a-button>
      </a-form-item>
    </a-form>
    <vxe-grid
      ref="modalTable"
      class="modal-table page-table"
      :columns="columns"
      :data="list"
      show-overflow="tooltip"
      show-header-overflow="tooltip"
      highlight-current-row
      row-id="id"
      :height="420"
      size="small"
      :loading="loading"
    >
      <template #empty>
        <div class="empty-icon">
          <sass-icon type="hi-nodata" style="font-size: 80px" />
        </div>
      </template>
      <template #pager>
        <div class="pager between-pager">
          <span class="counter">
            共<a href="javascript:void(0)">{{ total }}</a>条数据
          </span>
          <a-pagination
            v-model="pageNo"
            class="modal-page"
            :pageSize.sync="pageSize"
            :total="total"
            :pageSizeOptions="pageSizeOptions"
            show-size-changer
            show-quick-jumper
            @change="onPageChange"
            @showSizeChange="onSizeChange"
          />
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import moment from 'moment'
import { axios } from '@/utils/request'
export default {
  name: 'RecordTable',
  props: {
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      params: {
        fileName: '',
        taskDate: ['', '']
      },
      loading: false,
      columns: [
        {
          title: '文件名',
          field: 'fileName',
          slots: {
            default: ({ row }, h) => {
              return [
                <span>{this.type === 'dowload' ? row.fileName : row.userFileName }</span>
              ]
            }
          }
        },
        {
          title: '执行状态',
          field: 'taskResult',
          slots: {
            default: ({ row }, h) => {
              return [
                <span style="margin-right:5px"> <a-icon v-show={row.taskStatus === 3} type="check-circle" style="color: #1cb09f" />
                  <a-icon v-show={row.taskStatus === 2 || row.taskStatus === 1} type="clock-circle" style="color: #007AFE" />
                  <a-icon v-show={row.taskStatus <= 0} type="close-circle" style="color: #FB5146" />
                </span>,
                <span>{row.taskResult}</span>
              ]
            }
          }
        },
        {
          title: '执行时间',
          field: 'taskStartTime',
          slots: {
            default: ({ row }, h) => {
              return [row.taskStartTime ? moment(row.taskStartTime).format('YYYY-MM-DD HH:mm:ss') : '']
            }
          }
        },
        {
          title: '操作',
          width: '260px',
          fixed: 'right',
          slots: {
            default: ({ row }, h) => {
              return [
                <span>
                  <a-button type="link" v-show={this.type === 'dowload' && row.fileUrl} onClick={() => this.downloadFile(row.fileUrl, row.fileName)}>下载导出文件</a-button>
                  <a-button type="link" v-show={this.type === 'import' && row.userFileUrl} onClick={() => this.downloadFile(row.userFileUrl, row.userFileName)}>下载导入模板</a-button>
                  <a-button type="link" v-show={row.taskStatus < 0 && row.fileUrl} onClick={() => this.downloadErrorFile(row)}>下载错误详情</a-button>
                </span>
              ]
            }
          }
        }
      ],
      list: [],
      pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
      pageNo: 1,
      pageSize: 20,
      total: 0
    }
  },
  methods: {
    onReset() {
      this.params = {
        fileName: '',
        taskDate: ['', '']
      }
      this.onSizeChange(1, 20)
    },
    queryList() {
      const { fileName, taskDate } = this.params
      const data = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        fileName,
        taskType: this.type === 'import' ? 0 : 1
      }
      if ((taskDate.length === 2 && taskDate[0] && taskDate[1])) {
        data.taskStartTime = moment(taskDate[0]).format('YYYY-MM-DD')
        data.taskEndTime = moment(taskDate[1]).format('YYYY-MM-DD')
      }
      this.loading = true
      axios({
        url: '/finsaas-foundation/user-file-task/page',
        method: 'post',
        data
      }).then(res => {
        if (res.code === '0') {
          this.list = res.data
          this.total = res.total
        }
      }).catch(res => {
        this.$message.error(res.msg || '系统错误')
      }).finally(() => {
        this.loading = false
      })
    },
    onPageChange (page = 1) {
      this.pageNo = page
      this.queryList()
    },
    onSizeChange (page = 1, size = 20) {
      this.pageNo = page
      this.pageSize = size
      this.queryList()
    },
    async downloadErrorFile({ fileUrl, fileType, fileName }) {
      fileName = fileName.replace(/\.[^/.]+$/, '')
      await this.downloadFile(fileUrl, `${fileName}${fileType || '.txt'}`)
    },
    async downloadFile(url, filename) {
      try {
        // 发起请求
        const response = await fetch(url)
        if (!response.ok) {
          this.$message.error('文件下载失败')
          throw new Error('文件下载失败')
        }
        // 将响应转换为 Blob
        const blob = await response.blob()
        // 创建 Blob URL
        const blobUrl = window.URL.createObjectURL(blob)
        // 创建 <a> 标签并触发下载
        const link = document.createElement('a')
        link.href = blobUrl
        if (filename) link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        // 释放 Blob URL
        window.URL.revokeObjectURL(blobUrl)
        this.$message.success('文件下载成功')
      } catch (error) {
        this.$message.error(error)
      }
    }
  },
  created () {
    this.onPageChange(1)
  }
}
</script>
<style lang="less">
.import-dowload-record-table {
  .ant-form {
    margin-bottom: 15px;
    .ant-calendar-picker, .ant-input-search {
      width: 320px;
    }
  }
  .pager {
    padding-top: 14px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    &.between-pager {
      justify-content: space-between;
    }
  }
  .modal-page {
    .ant-pagination {
      display: inline-block;
      height: 24px;
      line-height: 1;
    }
    .go-btn {
      margin-left: 5px;
      position: relative;
      top: -7px;
    }
    input {
      margin: 0 5px;
    }
    .ant-pagination-item,
    .ant-pagination-prev,
    .ant-pagination-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next {
      height: 24px;
      line-height: 22px;
      min-width: 24px;
      font-size: 12px;
    }
    .ant-pagination-prev,
    .ant-pagination-item {
      margin-right: 5px;
    }
    .ant-pagination-options {
      margin-left: 5px;
    }
    .ant-pagination-options-quick-jumper {
      line-height: 24px;
      height: 24px;
      margin-left: 10px;
      input {
        height: 24px;
        line-height: 22px;
      }
    }
    .ant-pagination-options-size-changer.ant-select {
      margin-right: 0;
    }
    .ant-pagination-options-size-changer.ant-select
      .ant-select-selection--single,
    .ant-pagination-options-size-changer.ant-select
      .ant-select-selection--single
      .ant-select-selection__rendered {
      height: 24px;
      line-height: 22px;
    }
  }
}
</style>
